import { useState, useEffect, useCallback } from 'react';
import { errorNotificationManager } from '../services/errorNotificationService';
import { ErrorNotification } from '../types/errorNotifications';

export const useErrorNotifications = () => {
  const [notifications, setNotifications] = useState<ErrorNotification[]>([]);

  useEffect(() => {
    const unsubscribe = errorNotificationManager.subscribe(setNotifications);
    return unsubscribe;
  }, []);

  const showError = useCallback((title: string, message: string, options = {}) => {
    return errorNotificationManager.showError(title, message, options);
  }, []);

  const showWarning = useCallback((title: string, message: string, options = {}) => {
    return errorNotificationManager.showWarning(title, message, options);
  }, []);

  const showCritical = useCallback((title: string, message: string, options = {}) => {
    return errorNotificationManager.showCritical(title, message, options);
  }, []);

  const showInfo = useCallback((title: string, message: string, options = {}) => {
    return errorNotificationManager.showInfo(title, message, options);
  }, []);

  const showApiError = useCallback((error: any, defaultMessage?: string) => {
    return errorNotificationManager.showApiError(error, defaultMessage);
  }, []);

  const showValidationErrors = useCallback((errors: Record<string, string[]>) => {
    return errorNotificationManager.showValidationErrors(errors);
  }, []);

  const removeNotification = useCallback((id: string) => {
    errorNotificationManager.removeNotification(id);
  }, []);

  const clearAll = useCallback(() => {
    errorNotificationManager.clearAll();
  }, []);

  return {
    notifications,
    showError,
    showWarning,
    showCritical,
    showInfo,
    showApiError,
    showValidationErrors,
    removeNotification,
    clearAll
  };
};

export default useErrorNotifications;